import { generateApiUrl } from 'helpers/configHelper';

export const fetchData = async (path: string, query?: any) => {
    const url = generateApiUrl(buildURL(path, query));
    const response = await fetch(url);
    return response.json();
};

const buildURL = (path: string, query?: any) => {
    if (!query || Object.keys(query).length < 1) return path;
    const queryParams = new URLSearchParams(query);
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${queryParams}`;
};
